"use strict";

var _typeof = require("@babel/runtime-corejs2/helpers/typeof");
var _Reflect$construct = require("@babel/runtime-corejs2/core-js/reflect/construct");
var _WeakMap = require("@babel/runtime-corejs2/core-js/weak-map");
var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");
var _Object$getOwnPropertyDescriptor = require("@babel/runtime-corejs2/core-js/object/get-own-property-descriptor");
var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/extends"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/createClass"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/getPrototypeOf"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/inherits"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/defineProperty"));
var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/taggedTemplateLiteral"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireWildcard(require("react"));
var _styledComponents = _interopRequireWildcard(require("styled-components"));
var _stylingConstants = _interopRequireDefault(require("@gravity/styling-constants"));
var _themeProvider = require("@gravity/theme-provider");
var _utils = require("@gravity/utils");
var _themeMapper = require("@gravity/theme-mapper");
var _jsxFileName = "/codebuild/output/src3348638353/src/git-codecommit.eu-central-1.amazonaws.com/v1/repos/gravity/apps/tnwi/temp/ui/PopUp/lib/PopUp.js",
  _templateObject,
  _templateObject2,
  _templateObject3;
function _getRequireWildcardCache(e) { if ("function" != typeof _WeakMap) return null; var r = new _WeakMap(), t = new _WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = _Object$defineProperty && _Object$getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? _Object$getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? _Object$defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function cov_1htfk73i2f() {
  var path = "/codebuild/output/src3348638353/src/git-codecommit.eu-central-1.amazonaws.com/v1/repos/gravity/apps/tnwi/temp/ui/PopUp/lib/PopUp.js";
  var hash = "3f8dfb10dff972db757435dd395c422b68799294";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/codebuild/output/src3348638353/src/git-codecommit.eu-central-1.amazonaws.com/v1/repos/gravity/apps/tnwi/temp/ui/PopUp/lib/PopUp.js",
    statementMap: {
      "0": {
        start: {
          line: 10,
          column: 18
        },
        end: {
          line: 10,
          column: 34
        }
      },
      "1": {
        start: {
          line: 12,
          column: 16
        },
        end: {
          line: 83,
          column: 1
        }
      },
      "2": {
        start: {
          line: 88,
          column: 23
        },
        end: {
          line: 92,
          column: 1
        }
      },
      "3": {
        start: {
          line: 97,
          column: 4
        },
        end: {
          line: 97,
          column: 17
        }
      },
      "4": {
        start: {
          line: 98,
          column: 4
        },
        end: {
          line: 100,
          column: 6
        }
      },
      "5": {
        start: {
          line: 105,
          column: 4
        },
        end: {
          line: 105,
          column: 72
        }
      },
      "6": {
        start: {
          line: 109,
          column: 23
        },
        end: {
          line: 119,
          column: 3
        }
      },
      "7": {
        start: {
          line: 111,
          column: 4
        },
        end: {
          line: 113,
          column: 5
        }
      },
      "8": {
        start: {
          line: 112,
          column: 6
        },
        end: {
          line: 112,
          column: 13
        }
      },
      "9": {
        start: {
          line: 114,
          column: 4
        },
        end: {
          line: 118,
          column: 5
        }
      },
      "10": {
        start: {
          line: 115,
          column: 6
        },
        end: {
          line: 115,
          column: 45
        }
      },
      "11": {
        start: {
          line: 117,
          column: 6
        },
        end: {
          line: 117,
          column: 40
        }
      },
      "12": {
        start: {
          line: 122,
          column: 20
        },
        end: {
          line: 122,
          column: 42
        }
      },
      "13": {
        start: {
          line: 123,
          column: 4
        },
        end: {
          line: 128,
          column: 5
        }
      },
      "14": {
        start: {
          line: 125,
          column: 6
        },
        end: {
          line: 125,
          column: 73
        }
      },
      "15": {
        start: {
          line: 127,
          column: 6
        },
        end: {
          line: 127,
          column: 76
        }
      },
      "16": {
        start: {
          line: 129,
          column: 4
        },
        end: {
          line: 141,
          column: 6
        }
      },
      "17": {
        start: {
          line: 134,
          column: 14
        },
        end: {
          line: 134,
          column: 31
        }
      },
      "18": {
        start: {
          line: 145,
          column: 0
        },
        end: {
          line: 152,
          column: 2
        }
      },
      "19": {
        start: {
          line: 154,
          column: 0
        },
        end: {
          line: 157,
          column: 2
        }
      }
    },
    fnMap: {
      "0": {
        name: "(anonymous_0)",
        decl: {
          start: {
            line: 96,
            column: 2
          },
          end: {
            line: 96,
            column: 3
          }
        },
        loc: {
          start: {
            line: 96,
            column: 21
          },
          end: {
            line: 101,
            column: 3
          }
        },
        line: 96
      },
      "1": {
        name: "(anonymous_1)",
        decl: {
          start: {
            line: 104,
            column: 2
          },
          end: {
            line: 104,
            column: 3
          }
        },
        loc: {
          start: {
            line: 104,
            column: 20
          },
          end: {
            line: 106,
            column: 3
          }
        },
        line: 104
      },
      "2": {
        name: "(anonymous_2)",
        decl: {
          start: {
            line: 109,
            column: 23
          },
          end: {
            line: 109,
            column: 24
          }
        },
        loc: {
          start: {
            line: 109,
            column: 28
          },
          end: {
            line: 119,
            column: 3
          }
        },
        line: 109
      },
      "3": {
        name: "(anonymous_3)",
        decl: {
          start: {
            line: 121,
            column: 2
          },
          end: {
            line: 121,
            column: 3
          }
        },
        loc: {
          start: {
            line: 121,
            column: 11
          },
          end: {
            line: 142,
            column: 3
          }
        },
        line: 121
      },
      "4": {
        name: "(anonymous_4)",
        decl: {
          start: {
            line: 133,
            column: 22
          },
          end: {
            line: 133,
            column: 23
          }
        },
        loc: {
          start: {
            line: 133,
            column: 30
          },
          end: {
            line: 135,
            column: 13
          }
        },
        line: 133
      }
    },
    branchMap: {
      "0": {
        loc: {
          start: {
            line: 105,
            column: 11
          },
          end: {
            line: 105,
            column: 71
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 105,
            column: 32
          },
          end: {
            line: 105,
            column: 50
          }
        }, {
          start: {
            line: 105,
            column: 53
          },
          end: {
            line: 105,
            column: 71
          }
        }],
        line: 105
      },
      "1": {
        loc: {
          start: {
            line: 111,
            column: 4
          },
          end: {
            line: 113,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 111,
            column: 4
          },
          end: {
            line: 113,
            column: 5
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 111
      },
      "2": {
        loc: {
          start: {
            line: 111,
            column: 8
          },
          end: {
            line: 111,
            column: 49
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 111,
            column: 8
          },
          end: {
            line: 111,
            column: 17
          }
        }, {
          start: {
            line: 111,
            column: 21
          },
          end: {
            line: 111,
            column: 49
          }
        }],
        line: 111
      },
      "3": {
        loc: {
          start: {
            line: 114,
            column: 4
          },
          end: {
            line: 118,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 114,
            column: 4
          },
          end: {
            line: 118,
            column: 5
          }
        }, {
          start: {
            line: 116,
            column: 11
          },
          end: {
            line: 118,
            column: 5
          }
        }],
        line: 114
      },
      "4": {
        loc: {
          start: {
            line: 123,
            column: 4
          },
          end: {
            line: 128,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 123,
            column: 4
          },
          end: {
            line: 128,
            column: 5
          }
        }, {
          start: {
            line: 126,
            column: 11
          },
          end: {
            line: 128,
            column: 5
          }
        }],
        line: 123
      },
      "5": {
        loc: {
          start: {
            line: 131,
            column: 9
          },
          end: {
            line: 139,
            column: 9
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 131,
            column: 9
          },
          end: {
            line: 131,
            column: 16
          }
        }, {
          start: {
            line: 132,
            column: 10
          },
          end: {
            line: 138,
            column: 20
          }
        }],
        line: 131
      }
    },
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0,
      "11": 0,
      "12": 0,
      "13": 0,
      "14": 0,
      "15": 0,
      "16": 0,
      "17": 0,
      "18": 0,
      "19": 0
    },
    f: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0
    },
    b: {
      "0": [0, 0],
      "1": [0, 0],
      "2": [0, 0],
      "3": [0, 0],
      "4": [0, 0],
      "5": [0, 0]
    },
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "3f8dfb10dff972db757435dd395c422b68799294"
  };
  var coverage = global[gcv] || (global[gcv] = {});
  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }
  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_1htfk73i2f = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}
cov_1htfk73i2f();
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2.default)(o), (0, _possibleConstructorReturn2.default)(t, _isNativeReflectConstruct() ? _Reflect$construct(o, e || [], (0, _getPrototypeOf2.default)(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(_Reflect$construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
var _ref = (cov_1htfk73i2f().s[0]++, _stylingConstants.default),
  color = _ref.color;
var Wrapper = (cov_1htfk73i2f().s[1]++, (0, _utils.withThemedStyles)(_styledComponents.default.div.attrs({
  className: "g-PopUp"
}), (0, _defineProperty2.default)((0, _defineProperty2.default)({}, _themeProvider.TicketShopTheme.EQUILIBRIUM, (0, _styledComponents.css)(_templateObject || (_templateObject = (0, _taggedTemplateLiteral2.default)(["\n      position: absolute;\n      z-index: 101;\n      min-width: 300px;\n      padding: 20px;\n      border: 1px solid;\n      border-color: ", ";\n      background: ", ";\n      box-shadow: 1px 1px 0px ", ";\n      .arrow_box:after {\n        border-color: rgba(136, 183, 213, 0);\n        border-bottom-color: #88b7d5;\n        border-width: 30px;\n        margin-left: -30px;\n      }\n      .arrow_box:before {\n        border-color: rgba(194, 225, 245, 0);\n        border-bottom-color: #c2e1f5;\n        border-width: 31px;\n        margin-left: -31px;\n      }\n      .arrow_box:after,\n      .arrow_box:before {\n        bottom: 100%;\n        left: 50%;\n        border: solid transparent;\n        content: ' ';\n        height: 0;\n        width: 0;\n        position: absolute;\n        pointer-events: none;\n      }\n    "])), color.greyLight, color.baseBackground, color.greyLight)), _themeProvider.TicketShopTheme.EVOLUTION, (0, _styledComponents.css)(_templateObject2 || (_templateObject2 = (0, _taggedTemplateLiteral2.default)(["\n      position: absolute;\n      z-index: 101;\n      padding: 20px;\n      background: ", ";\n      border: none;\n      min-width: ", ";\n      box-shadow: none;\n      .arrow_box:after {\n        border-color: rgba(136, 183, 213, 0);\n        border-bottom-color: #88b7d5;\n        border-width: 30px;\n        margin-left: -30px;\n      }\n      .arrow_box:before {\n        border-color: rgba(194, 225, 245, 0);\n        border-bottom-color: #c2e1f5;\n        border-width: 31px;\n        margin-left: -31px;\n      }\n      .arrow_box:after,\n      .arrow_box:before {\n        bottom: 100%;\n        left: 50%;\n        border: solid transparent;\n        content: ' ';\n        height: 0;\n        width: 0;\n        position: absolute;\n        pointer-events: none;\n      }\n    "])), color.baseBackground, _themeMapper.evolutionTheme.popup.minWidth))));

/**
 * Component to display a simple popup with a content we pass as children.
 */
var ContentWrapper = (cov_1htfk73i2f().s[2]++, _styledComponents.default.div.attrs({
  className: 'g-PopUp-content'
})(_templateObject3 || (_templateObject3 = (0, _taggedTemplateLiteral2.default)(["\n  position: relative;\n"]))));

/** Component to display a pop up component */
var PopUp = /*#__PURE__*/function (_Component) {
  function PopUp(props) {
    var _this;
    (0, _classCallCheck2.default)(this, PopUp);
    cov_1htfk73i2f().f[0]++;
    cov_1htfk73i2f().s[3]++;
    _this = _callSuper(this, PopUp, [props]);
    /** Method to close the pop up when the user clicks out of the component */
    (0, _defineProperty2.default)(_this, "handleOutsideClick", (cov_1htfk73i2f().s[6]++, function (e) {
      cov_1htfk73i2f().f[2]++;
      cov_1htfk73i2f().s[7]++;
      // ignore clicks on the component itself
      if ((cov_1htfk73i2f().b[2][0]++, _this.node) && (cov_1htfk73i2f().b[2][1]++, _this.node.contains(e.target))) {
        cov_1htfk73i2f().b[1][0]++;
        cov_1htfk73i2f().s[8]++;
        return;
      } else {
        cov_1htfk73i2f().b[1][1]++;
      }
      cov_1htfk73i2f().s[9]++;
      if (_this.props.onClose) {
        cov_1htfk73i2f().b[3][0]++;
        cov_1htfk73i2f().s[10]++;
        _this.props.onClose(_this.props.visible);
      } else {
        cov_1htfk73i2f().b[3][1]++;
        cov_1htfk73i2f().s[11]++;
        _this.setState({
          visible: false
        });
      }
    }));
    cov_1htfk73i2f().s[4]++;
    _this.state = {
      visible: props.visible
    };
    return _this;
  }

  // get the visible value from state or props depending which component handle the state
  (0, _inherits2.default)(PopUp, _Component);
  return (0, _createClass2.default)(PopUp, [{
    key: "getVisibleState",
    value: function getVisibleState() {
      cov_1htfk73i2f().f[1]++;
      cov_1htfk73i2f().s[5]++;
      return this.props.onClose ? (cov_1htfk73i2f().b[0][0]++, this.props.visible) : (cov_1htfk73i2f().b[0][1]++, this.state.visible);
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;
      cov_1htfk73i2f().f[3]++;
      var visible = (cov_1htfk73i2f().s[12]++, this.getVisibleState());
      cov_1htfk73i2f().s[13]++;
      if (visible) {
        cov_1htfk73i2f().b[4][0]++;
        cov_1htfk73i2f().s[14]++;
        // attach/remove event handler
        document.addEventListener('click', this.handleOutsideClick, false);
      } else {
        cov_1htfk73i2f().b[4][1]++;
        cov_1htfk73i2f().s[15]++;
        document.removeEventListener('click', this.handleOutsideClick, false);
      }
      cov_1htfk73i2f().s[16]++;
      return /*#__PURE__*/_react.default.createElement("div", {
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 130,
          columnNumber: 7
        }
      }, (cov_1htfk73i2f().b[5][0]++, visible) && (cov_1htfk73i2f().b[5][1]++, /*#__PURE__*/_react.default.createElement(Wrapper, (0, _extends2.default)({
        innerRef: function innerRef(node) {
          cov_1htfk73i2f().f[4]++;
          cov_1htfk73i2f().s[17]++;
          _this2.node = node;
        }
      }, this.props, {
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 132,
          columnNumber: 11
        }
      }), /*#__PURE__*/_react.default.createElement(ContentWrapper, {
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 137,
          columnNumber: 13
        }
      }, this.props.children))));
    }
  }]);
}(_react.Component);
cov_1htfk73i2f().s[18]++;
PopUp.propTypes = {
  /** True to show the popup. False to hide it. */
  visible: _propTypes.default.bool,
  /** Content to display inside the popup */
  children: _propTypes.default.node.isRequired,
  /** if passed as parameter, the parent will manage the visibility of the component with the prop 'visible' */
  onClose: _propTypes.default.func
};
cov_1htfk73i2f().s[19]++;
PopUp.defaultProps = {
  visible: false,
  onClose: undefined
};
var _default = exports.default = PopUp;